import type { ComputedRef } from "vue";
import type { DialogLabelKind } from "../../components/Dialog/dialogLabels";
import { computed, getCurrentInstance, inject, onBeforeUnmount } from "vue";
import { DIALOG_LABELS_KEY } from "../../components/Dialog/dialogLabels";

/**
 * Names the surrounding dialog with this element: bind the returned id on the title (or description) element.
 * It is `undefined` outside a dialog, when another element already names the dialog, and while `present` is false.
 */
export function useDialogLabel(kind: DialogLabelKind, present?: () => boolean): ComputedRef<string | undefined> {
  const labels = inject(DIALOG_LABELS_KEY, null);
  if (!labels) {
    return computed(() => undefined);
  }

  const claim = labels.claim(kind, present);
  if (getCurrentInstance()) {
    onBeforeUnmount(claim.release);
  }

  return computed(() => claim.id());
}
